export default ['$uibModalInstance', 'text', 'title', 'hideCloseButton', function ($uibModalInstance, text, title, hideCloseButton) {
  this.text = text;
  this.title = title;
  this.showCloseButton = !hideCloseButton;

  this.close = () => {
    $uibModalInstance.dismiss();
  };
}];
